// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2iPQz","footer":"ModalFilter_footer__s__Fx"};